import {
  startAuthentication,
  startRegistration,
} from "@simplewebauthn/browser";
import { AuthPasskeyChallengeLoginResponse } from "../core/api/requests/auth/passkey_challenge_login/types";
import { AuthPasskeyChallengeRegisterResponse } from "../core/api/requests/auth/passkey_challenge_register/types";

export const useWebAuthn = () => {
  const registration = (result: AuthPasskeyChallengeRegisterResponse) => {
    const payload = result.challenge;
    return startRegistration({
      optionsJSON: {
        challenge: payload.challenge,
        rp: payload.rp,
        user: {
          displayName: payload.user.display_name,
          id: payload.user.id,
          name: payload.user.name,
        },
        pubKeyCredParams:
          payload.pub_key_cred_params as PublicKeyCredentialParameters[],
        timeout: payload.timeout,
        attestation: payload.attestation as AttestationConveyancePreference,
        excludeCredentials: payload.exclude_credentials,
      },
    });
  };

  const authentication = (result: AuthPasskeyChallengeLoginResponse) => {
    const challenge = result.challenge;
    return startAuthentication({
      optionsJSON: {
        challenge: challenge.challenge,
        rpId: challenge.rp_id,
        userVerification:
          challenge.user_verification as UserVerificationRequirement,
        allowCredentials: challenge.allow_credentials as any[],
        timeout: challenge.timeout,
      },
    });
  };

  return {
    registration,
    authentication,
  };
};
